import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('PRODUCTS', ['CATEGORY', 'STATE', 'VIEW'])
